export default __webpack_public_path__ + "0457b6fa8ad30447f655a0c4f205c6a5.svg";